import PropTypes from 'prop-types';
import styles from './FilterOptions.module.css';
import { setGradebookFilterTypes } from '../../../../actions/gradebook';
import { isGradebookV2ActiveSelector } from '../../../../selectors/search-gradebook';
import { connect } from 'react-redux';
import {
  addResourceTypeFilters,
  isResourceTypeFilterOptionActive,
  removeResourceTypeFilters,
} from '@macmillan-learning/gradebook-shared';
import MLCheckBox from '../../../MLCheckBox/MLCheckBox';
import FilterSection from './FilterSection';
import { RESOURCE_TYPE_GB_FILTER_SECTION_ID } from '../../../../utils/constants';
import { getAllResourceTypeFilterOptions } from '../../../../utils/util';

const RESOURCE_TYPE_FILTER_SECTION_HEADER = 'Resource Type';

function ResourceTypeFilterSection(props) {
  const { dispatch, visibleFilter, resourceTypes } = props;
  const filterOptions = getAllResourceTypeFilterOptions();

  const toggleFilterType = (filters, addType) => {
    const updatedResourceTypes = addType
      ? addResourceTypeFilters(resourceTypes, filters)
      : removeResourceTypeFilters(resourceTypes, filters);
    dispatch(setGradebookFilterTypes(updatedResourceTypes));
  };

  const renderCheckBox = (filterOption) => {
    const { label, filters } = filterOption;
    const isChecked = isResourceTypeFilterOptionActive(resourceTypes, filters);
    return (
      <MLCheckBox
        className={styles.checkBox}
        labelText={label}
        checked={isChecked}
        onChange={(_, addType) => toggleFilterType(filters, addType)}
      />
    );
  };

  return (
    <FilterSection
      dispatch={dispatch}
      visibleFilter={visibleFilter}
      id={RESOURCE_TYPE_GB_FILTER_SECTION_ID}
      headerText={RESOURCE_TYPE_FILTER_SECTION_HEADER}
    >
      <div className={styles.filterOptionsTypeContainer}>
        {filterOptions.map((filterOption, index) => (
          <div key={index} className={styles.filterOptionsTypeRow}>
            {renderCheckBox(filterOption)}
          </div>
        ))}
      </div>
    </FilterSection>
  );
}

ResourceTypeFilterSection.propTypes = {
  dispatch: PropTypes.func,
  visibleFilter: PropTypes.string,
  resourceTypes: PropTypes.array,
  isGradebookV2Active: PropTypes.bool.isRequired,
};

function mapStateToProps(state) {
  return {
    isGradebookV2Active: isGradebookV2ActiveSelector(state),
  };
}

export default connect(mapStateToProps)(ResourceTypeFilterSection);
